import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import auth from './../service/auth';
import {user} from './modules/user.module';
import {parametro} from "./modules/parametro.module";
import {menus} from "./modules/menu.module";
import {roles} from "./modules/role.module";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cognitoInfo: null,
    cognitoError: null,
    loggedIn: false,
    loadingState: true,
    errorLoadingState: false,
    initApp: false
  },
  mutations: {
    InfoCognitoSuccess(state, data) {
      state.cognitoInfo = data;
    },

    InfoCognitoFailure(state, error) {
      state.cognitoError = error;
    },

    setLoggedIn(state, valor) {
      state.loggedIn = valor;
    },
    setLoggedOut(state) {
      state.loggedIn = false;
      state.cognitoInfo = null;
    },
    setInitApp(state, value) {
      state.initApp = value;
    }
  },
  actions: {
    getUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        const jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
        const USERINFO_URL = 'https://' + auth.auth.getAppWebDomain() + '/oauth2/userInfo';
        const requestData = {
          headers: {
            'Authorization': 'Bearer ' + jwtToken
          }
        }
        axios.get(USERINFO_URL, requestData)
          .then(response => {
          commit('InfoCognitoSuccess', response.data)
          resolve(true)
        })
          .catch(error => {
            commit('InfoCognitoFailure', error)
            reject(false)
          });
      })
    },
    setInitApp({ commit }, value) {
      commit('setInitApp', value)
    }
  },
  modules: {
    user,
    parametro,
    menus,
    roles
  }
})
